import React from "react"
import Icon from "@kit/design/icon"

export function SectionPreview() {
  return (
    <div className="flex items-center">
      <div className="w-6 h-6 flex items-center justify-center mr-4">
        <Icon name="star" />
      </div>
      <div>Section</div>
    </div>
  )
}
